// export const API_BASE_URL = 'http://localhost:3000/api'
export const API_BASE_URL = 'https://api.bizzhub.co.in/api'
// export const API_BASE_URL = 'https://api.bizzhub.work/api'
